import React from "react";
import ToscaContent from "../function-components/learningCourses/ToscaContent";

export default function TOSCA() {
  return (
    <>
      <ToscaContent />
    </>
  );
}
